import useAuth from "@hooks/useAuth";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { BellIcon, Gift, LogOut, Receipt, Users } from "lucide-react";
import { useSelector } from "react-redux";
import { RootState } from "@redux/store";
import React, { useEffect, useState } from "react";
import { getUsers, UserAccount } from "@redux/slices/auth";
import { useNavigate } from "react-router";
import { getUnreadNotificationsCount } from "@redux/slices/notifications";
const Navbar = () => {
  const [selectedUser, setSelectedUser] = React.useState<UserAccount>();
  const [unreadCount, setUnreadCount] = useState(0);

  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const selectedUserId = useSelector(
    (state: RootState) => state.user.selectedUserId
  );

  React.useEffect(() => {

    const fetchUsers = async () => {
      try {
        const data = await getUsers();
        const filteredData = data?.filter((i: any) => i.id === selectedUserId);
        setSelectedUser(filteredData && filteredData[0]);
      } catch (err) {
        console.error("Error fetching campaign stats:", err);
      }
    };
    fetchUsers();

  }, [selectedUserId]);

  useEffect(() => {

    const setIntial = async () => {
      try {
        const data = await getUsers();
        // const filteredData = data;
        const filteredData = data || [];
        setSelectedUser(filteredData.length > 0 ? filteredData[0] : undefined);
      } catch (err) {
        console.error("Error fetching campaign stats:", err);
      }
    };
    setIntial();
    
  }, []);

  useEffect(() => {
    const fetchUnreadCount = async () => {
      const count = await getUnreadNotificationsCount();
      setUnreadCount(count);
    };

    fetchUnreadCount();
  }, []);

  return (
    <nav className="w-[100%] flex items-center justify-between md:pb-5 ">
      <div className="w-1/2 font-semibold text-lg">
        {/* <SearchInput /> */}
        {user?.role == "admin" ? selectedUser?.email : user?.email}
      </div>
      <div className="flex items-center">
        {user?.role === "admin" && (
          <div className="relative">

            <BellIcon
              className="me-5 cursor-pointer"
              size={25}
              onClick={() => navigate("/notifications")}
            />
            <p className="absolute -top-3 right-3 bg-red-600 text-[9px] text-white font-semibold px-2 py-1 rounded-full h-fit">{unreadCount}</p>
          </div>
        )}
        <DropdownMenu>
          <DropdownMenuTrigger className="w-full outline-none border-none focus:outline-none ">
            <img
              src={
                user?.photo_url
                  ? user.photo_url
                  : "assets/images/dummy_profile.png"
              }
              alt="logo"
              height={36}
              width={36}
              className="rounded-full cursor-pointer border border-white/30 p-[1px]"
            />
          </DropdownMenuTrigger>
          <DropdownMenuContent className="w-44">
            <DropdownMenuItem>
              <img
                src={
                  user?.photo_url
                    ? user.photo_url
                    : "assets/images/dummy_profile.png"
                }
                alt="logo"
                height={16}
                width={16}
                className="mr-3 rounded-full cursor-pointer"
              />{" "}
              {user?.first_name + " " + user?.last_name || ""}
            </DropdownMenuItem>
            <DropdownMenuSeparator />

            {/* <DropdownMenuLabel className="text-black/20">
              Settings
            </DropdownMenuLabel>

            <Link to="/settings">
              <DropdownMenuItem>
                <Gift size={16} className="mr-2 text-primary" />
                What&apos;s New
              </DropdownMenuItem>
            </Link>
            <Link to="/settings">
              <DropdownMenuItem>
                <Users size={16} className="mr-2 text-primary" />
                Teammates
              </DropdownMenuItem>
            </Link>
            <Link to="/settings">
              <DropdownMenuItem>
                <Receipt size={16} className="mr-2 text-primary" />
                Billing
              </DropdownMenuItem>{" "}
            </Link> */}

            <DropdownMenuItem onClick={logout}>
              <LogOut size={16} className="mr-2 text-primary" />
              Sign Out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </nav>
  );
};

export default Navbar;
